import { Pagination } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import ContactForm from '../../components/ContactForm';
import { useEffect, useState } from 'react';
import { appType, contactType } from '../../components/constant';
import { StyledPagination } from '../../StyledComponets';
import { CNT_KEY } from '../../components/ContactForm/helpers';
import withLayout from '../../components/Layout/withLayout';
import SystemInfo from '../../components/DERSystemInfo';
import { buildPreAppRequest, reBuildCustomerData } from './apiHelpers';
import { createProjectData, getProjectData, resetProjectStateReducer } from '../../app/projects/createProjectSlice';
import { getUserData } from '../../app/environment/userSlice';
import { getCustomerData, resetCustomerDataReducer } from '../../app/contact/getCustomerSlice';
import { resetCityStateReducer } from '../../app/contact/contactSlice';


export function PreApp(props) {
const { isClickable, pageType, detailsData } = props;
  const [pageactive, setActivePage] = useState(1);
  const [sectionData, setSectionData] = useState([]);
  const dispatch = useDispatch();
  const projectData = useSelector(getProjectData);
  const userData = useSelector(getUserData);
  const cusAcctData = useSelector(getCustomerData);


  useEffect(() => {
    return () => {
      resetAppState();
    };
  }, []);
  const setActiveAndDisabledProps = (sectionKey) => {
    return {
      active: pageactive === sectionKey,
      disabled: isClickable ? false : pageactive !== sectionKey,
      ...(isClickable
        ? {
            onClick: onSectionClick,
          }
        : {}),
    };
  };

  const onSectionClick = (e) => {
    setActivePage(e.target.tabIndex);
    //CALL API TO GET DEATILS
  };

  const resetAppForm = () => {
    setSectionData([]);
    setActivePage(1);
  };

  
  const resetAppState = () =>{
    dispatch(resetCityStateReducer());
    dispatch(resetProjectStateReducer());
    dispatch(resetCustomerDataReducer())
  }

  const setSection = (isNext, data) => {
    //SET SECTION DATA ON CLICK
    const sectionItem = sectionData.find((x) => x.id === pageactive);
    const sIndex = sectionData.indexOf(sectionItem);
    if (sIndex >= 0) {
      const updateItem = {
        ...sectionItem,
        ...(data ? { data: data } : {}),
      };
      const newState = [...sectionData];
      newState[sIndex] = updateItem;
      setSectionData(newState);
    } else {
      setSectionData([...sectionData, { id: pageactive, data: data }]);
    }
    //SET NEXT OR PREVIOUS SECTION
   if (isNext!==null){
    isNext ? setActivePage(pageactive + 1) : setActivePage(pageactive - 1);
   }
   
  };

  const setPreviousData = (isApplicant, data) => {
    const sid = isApplicant ? 1 : 2;
    const previousData = sectionData.find((x) => x.id === sid);
    delete previousData.data[CNT_KEY.SAME_CD];

    const sectionItem = sectionData.find((x) => x.id === pageactive);
    const sIndex = sectionData.indexOf(sectionItem);
    if (sIndex >= 0) {
      const updateItem = {
        ...sectionItem,
        data: data ?? previousData?.data,
      };
      const newState = [...sectionData];
      newState[sIndex] = updateItem;
      setSectionData(newState);
    } else {
      setSectionData([
        ...sectionData,
        { id: pageactive, data: data ?? previousData?.data },
      ]);
    }
  };

  const createOrSaveProject = (actionType) => {
    const reqObj = buildPreAppRequest(
      projectData,
      sectionData,
      appType.PREAPP,
      userData,
      cusAcctData,
      actionType
    );
    dispatch(createProjectData(reqObj));
  };

  return (
    <>
      <StyledPagination>
        <Pagination.Item {...setActiveAndDisabledProps(1)} tabIndex={1}>
          Service Information
        </Pagination.Item>
        <Pagination.Item {...setActiveAndDisabledProps(2)} tabIndex={2}>
          Applicant Information
        </Pagination.Item>
        <Pagination.Item {...setActiveAndDisabledProps(3)} tabIndex={3}>
          DER System
        </Pagination.Item>
      </StyledPagination>
      {pageactive === 1 && (
        <ContactForm
          key={1}
          type={contactType.service}
          setSection={setSection}
          formData={isClickable ? {
            data: reBuildCustomerData(
              detailsData?.appEnrollmentSummary
            ),
          } : sectionData.find((x) => x?.id === 1)}
          isProjectDetailsView={isClickable}
          pageType={pageType}
          noBack={true}
          showPosition={true}
          showAccount={true}
          showCommonForm={false}
        />
      )}
      {pageactive === 2 && (
        <ContactForm
          key={2}
          type={contactType.applicant}
          setSection={setSection}
          formData={
            isClickable
              ? { data: detailsData?.appEnrollmentSummary?.applicant }
              : sectionData.find((x) => x?.id === 2)
          }
          isProjectDetailsView={isClickable}
          pageType={pageType}
          noBack={false}
          showPosition={false}
          showAccount={false}
          showCommonForm={true}
        />
      )}
      {pageactive === 3 && (
        <SystemInfo
          key={3}
          pageType={pageType}
          isProjectDetailsView={isClickable}
          createOrSaveProject={createOrSaveProject}
          resetAppForm={resetAppForm}
          setSection={setSection}
          formData={
            isClickable ? { data: null } : sectionData.find((x) => x?.id === 3)
          }
        />
      )}
    </>
  );
}

export default withLayout(PreApp);
